export interface DataType {
  key: string;
  id:number,
  nickName: string;
  sourceChannel: string;
  exchangeCount: number;
  activityCount: number;
  mobile: string;
  registerTime: string;
  lastLoginTime: string;
}

export const column = [
  {
    title: '用户ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
    key: 'mobile',
  },
  {
    title: '来源渠道',
    dataIndex: 'cpsTypeName',
    key: 'cpsTypeName',
  },
  {
    title: '供货渠道',
    dataIndex: 'supplyChannelName',
    key: 'supplyChannelName',
  },
  {
    title: '权益包数量',
    dataIndex: 'activityCount',
    key: 'activityCount',
  },
]